import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'
import { compose } from 'recompose'
import styles from './notification-content.styl'
import { Link } from 'react-router-dom'

const enhance = compose(
  injectIntl
)
class NotificationContent extends Component {
  static propTypes = {
    message: PropTypes.string,
    intl: PropTypes.object,
    showCopyLink: PropTypes.bool
  }

  copyToClipboard = text => {
    const el = document.createElement('textarea')

    el.value = text
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)
  }

  render() {
    const { message, showCopyLink } = this.props

    return (
        <div className={`${styles.contentWrapper}`}>
          <div className={`${styles.message}`}><p>{message}</p></div>

          {showCopyLink && <div className={`${styles.link}`}>
            <Link onClick={() => this.copyToClipboard(message)}><span className={`${styles.icon}`} />
              <FormattedMessage
                  id="button.copy_to_clipboard"
                  defaultMessage="Copy to clipboard"
              />
            </Link>
          </div>}
           <div style={{ clear: 'both' }}></div>
        </div>
    )
  }
}

export default enhance(NotificationContent)
